import { gql } from '__generated__';

export default gql(`
  query GetAuthenticatorSecret {
    authenticatorSecret {
      secret
      qr
    }
  }
`);
